import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./DownloadBundleCard.module.scss";
import ProgressBarDownload from "./ProgressBarDownload";

const DownloadRow = ({
  title,
  subtitle,
  icon,
  onClick,
  progress = 0,
  disabled = false,
  badge,
}) => {
  const isRunning = progress > 0 && progress < 100;
  const { t } = useTranslation();

  return (
    <div className={styles.row}>
      <div className={styles.left}>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.texts}>
          <div className={styles.titleLine}>
            <h4 className={styles.title}>{title}</h4>
            {badge && <span className={styles.badge}>{badge}</span>}
          </div>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </div>

      <div className={styles.right}>
        <button
          type="button"
          className={styles.btn}
          onClick={onClick}
          disabled={disabled || isRunning}
          title={disabled ? t("download.action_unavailable") : t("download.download_button")}
        >
          {isRunning ? t("download.downloading") : t("download.download_button")}
        </button>
      </div>

      {/* Progress sous la ligne si actif */}
      <div className={styles.progressWrap}>
        <ProgressBarDownload progress={progress} />
      </div>
    </div>
  );
};

const DownloadBundleCard = ({
  // actions
  onDownloadHearing,
  onDownloadWords,
  onDownloadManual,

  // progress
  progressHearing = 0,
  progressWord = 0,
  progressManual = 0,

  // UI
  title,

  canDownloadZips = true, // permission
  isMobile = false,

  // icons
  iconHearing,
  iconWords,
  iconManual,
}) => {
  const { t } = useTranslation();
  const anyDownloading =
    (progressHearing > 0 && progressHearing < 100) ||
    (progressWord > 0 && progressWord < 100);

  return (
      <div className={styles.card}>
      <div className={styles.header}>
        <div>
          <h3 className={styles.cardTitle}>{title}</h3>
        </div>
      </div>

      <div className={styles.rows}>
        <DownloadRow
          title={t("download.hearing_space")}
          subtitle={t("download.download_program")}
          icon={iconHearing}
          onClick={onDownloadHearing}
          progress={progressHearing}
          disabled={!canDownloadZips || isMobile || anyDownloading}
          badge={isMobile ? t("download.pc_required") : "ZIP"}
        />

        <DownloadRow
          title={t("download.cna_list")}
          subtitle={t("download.cna_subtitle")}
          icon={iconWords}
          onClick={onDownloadWords}
          progress={progressWord}
          disabled={!canDownloadZips || isMobile || anyDownloading}
          badge={isMobile ? t("download.pc_required") : "ZIP"}
        />

        <DownloadRow
          title={t("download.user_manual")}
          subtitle={t("download.manual_subtitle")}
          icon={iconManual}
          onClick={onDownloadManual}
          progress={progressManual}
          badge="PDF"
        />

      </div>

      {isMobile && canDownloadZips && (
        <div className={styles.mobileHint}>
          {t("download.mobile_hint")}
        </div>
      )}
    </div>
  );
};

export default DownloadBundleCard;
